module.exports = __webpack_public_path__ + "img/rocco_girardi.b6ff0c6c.jpg";